export default {
  SAVE_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    state.userInfo.key = (state.userInfo.key ?? 0) + 1;
  },
  CLEAR_USER(state) {
    state.userInfo = null;
  }
}